import React from 'react'

import Chart from '../pie-chart'
import List from '../chart-list'
import { Empty, Skeleton, Icon } from 'antd'

import './styles.scss'

class CategoriesChart extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeIndex: 0, loading: false, data: [], error: false }
    this.colors = [
      '#0088FE',
      '#00C49F',
      '#FFBB28',
      '#FF8042',
      '#EC407A',
      '#7E57C2',
      '#EF5350',
      '#AFB42B',
    ]
  }

  componentWillReceiveProps(nextProps) {
    const { selectedCloud } = nextProps
    if (selectedCloud && selectedCloud !== this.props.selectedCloud) {
      this.props.loadData(
        selectedCloud,
        this.onStart,
        this.onSuccess,
        this.onFail
      )
    }
  }

  componentDidMount() {
    const { selectedCloud } = this.props
    if (selectedCloud) {
      this.props.loadData(
        selectedCloud,
        this.onStart,
        this.onSuccess,
        this.onFail
      )
    }
  }

  onStart = () => {
    this.setState({ loading: true, error: false })
  }
  onSuccess = data => {
    this.setState({
      data,
      loading: false,
      error: false,
    })
  }

  onFail = () => {
    this.setState({
      data: [],
      error: true,
      loading: false,
    })
  }

  setActiveCell = index => {
    this.setState({ activeIndex: index })
  }

  render() {
    const { data, activeIndex, loading, error } = this.state
    return (
      <div className="categories-chart">
        {error ? (
          <div className="error">
            <Icon type="frown" /> <div>Could not load data.</div>
          </div>
        ) : loading ? (
          <Skeleton
            title={false}
            paragraph={{ rows: 14, width: '100%' }}
            active
          />
        ) : !data.length ? (
          <Empty />
        ) : (
          <>
            <Chart
              data={data}
              colors={this.colors}
              setActiveCell={this.setActiveCell}
              activeIndex={activeIndex}
            />
            <List
              data={data}
              colors={this.colors}
              setActiveCell={this.setActiveCell}
              activeIndex={activeIndex}
              setCurrentCategory={() => {}}
            />
          </>
        )}
      </div>
    )
  }
}

export default CategoriesChart
